import { render } from "./CommandesView.vue?vue&type=template&id=08066f1c&scoped=true"
import script from "./CommandesView.vue?vue&type=script&lang=js"
export * from "./CommandesView.vue?vue&type=script&lang=js"

import "./CommandesView.vue?vue&type=style&index=0&id=08066f1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08066f1c"]])

export default __exports__